export default "__VITE_ASSET__Bl_rfQai__"